export interface IS3Data {
  bucket: string;
  folder: string;
  region: string;
  accessKeyId?: string;
  secretAccessKey?: string;
}

// start upload

export interface IParamStartUpload {
  fileName: string;
  fileType: string;
  bucket: string;
}

// single file

export interface IFileItem {
  relativePath: string;
  file: File;
  status: number; // 0 not upload || 1 yes upload
  token: string;
  progress?: number;
  type?: string;
  compressedFiles?: File[];
}

// folder

export interface IFolderItem {
  name: string;
  relativePath: string;
  file: File;
  status: number; // 0 not upload || 1 yes upload
  token: string;
  type?: string;
  progress?: number;
  compressedFiles?: File[];
}

export interface IFolderList {
  type: string;
  token: string;
  name: string;
  realName: string;
  oneValidFile: boolean;
  files: IFolderItem[];
  compress: IFolderItem[];
  progress?: number;
}

export class FolderListClass implements IFolderList {
  type: string;
  token: string;
  name: string;
  realName: string;
  oneValidFile: boolean;
  files: IFolderItem[];
  compress: IFolderItem[];
  progress?: number;

  constructor(params?: IFolderList) {
    this.type = params?.type || '';
    this.token = params?.token || '';
    this.name = params?.name || '';
    this.realName = params?.realName || '';
    this.oneValidFile = !!params?.oneValidFile;
    this.files = params?.files || [];
    this.compress = params?.compress || [];
    this.progress = params?.progress || 0;
  }
}
